import { Component } from '@angular/core';
import { OneFeildMasterService } from '../../Model/OneFeildMasters/one-feild-master.service';
import { ShareTypeService } from '../../Model/OneFeildMasters/share-type.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-add-master',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master.component.html',
  styleUrl: './add-master.component.scss'
})
export class AddMasterComponent {
  public User: any = null;
  Detail = {
    Name: '',
    Active: 0,
    SelectType: '',
    ID: 0,
    editMode: false,
  } 
  div : string = '';
  onCheckboxChange(event: any) {
    this.Detail.Active = event.target.checked ? 1 : 0;
    console.log(this.Detail.Active);
  }
  constructor(
    private oneFeildservie: OneFeildMasterService,
    private sharetype: ShareTypeService,
    private sessionService: SessionService,
    private toast: ToastService,
    private router : Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) { }
  ngOnInit(): void {
    const TypeOfSigleFieldMaster = sessionStorage.getItem('TypeOfSingleFieldMaster');
    console.log(TypeOfSigleFieldMaster);
    if (TypeOfSigleFieldMaster != null) {
      this.Detail.SelectType = TypeOfSigleFieldMaster
    }   
    this.sharetype.SEMode$.subscribe(editMode => {
      this.Detail.editMode = editMode;  
      if( this.Detail.editMode == true){
        const detailsString = sessionStorage.getItem('Details');
        if (detailsString) {  
          const Details = JSON.parse(detailsString);
          console.log('myyyyyyy', Details);
          this.Detail.Name = Details.Name;
          this.Detail.ID = Details.ID;
          if (Details.Active == 'Y') {
            this.Detail.Active = 1
          }
          else if (Details.Active == 'N') {
            this.Detail.Active = 0
          }
        }
      }
      else{
        this.Detail.Name = '';
        this.Detail.Active = 0;
        this.Detail.ID = 0 ;
      }
    });
  }

  save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.saveInsert();
      }
    }).catch(() => {

    });
  }
  saveInsert(): void {
    this.User = this.sessionService.GetUserDetails();
    if (this.Detail.Name != '') {
      const ofiData = {
        OperationType: this.Detail.editMode ? 2 : 1,
        MasterType: this.Detail.SelectType,
        ID: this.Detail.ID,
        Name: this.Detail.Name,
        MasterID: 0,
        Active: this.Detail.Active,
        By: parseInt(this.User.UserId),
        OutputID: 0,
        AcNoLength: 0,
        Code: '0',
        DesignationCategoryId: 0,
        DeductionAmount: 0,
        Installment: 0,
        DutyDivideBy: 0,
      };
      this.oneFeildservie.OneFieldInsert(ofiData).subscribe(
        data => {
          console.log('API Response:', data);
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          const DIV = sessionStorage.getItem('Div');
          if (DIV != null) {
            this.div = DIV
            console.log('this.div data', this.div);
            this.activeModal.close();
          }  
          this.router.navigate(['MISMaster/'+this.div]);
        },
        error => {
          console.error('Error:', error);
        });

      this.Detail.editMode = false;
      this.Detail.Name = ''
      this.Detail.Active = 0
      this.sharetype.SEditMode(this.Detail.editMode);
    }
    else {
      this.toast.show({ message: `Message: Please Fill the Data.`, type: toastTypeEnum.warning });
    }
  }
  cancel() {
    this.Detail.editMode = false
    this.sharetype.SEditMode(this.Detail.editMode);
    this.activeModal.close(); 
    const DIV = sessionStorage.getItem('Div');
    if (DIV != null) {
      this.div = DIV
    }
   // this.router.navigate(['MISMaster/'+this.div]);
  }
}
